import axios from "axios";
import { API } from "../config";

export const getYoutubePageCount = async () => {
  return axios.get(API.VIDEO + `/pageCount`, {});
};

export const getYoutubeVideo = async (currentPage) => {
  return axios.get(API.VIDEO + `?page=${currentPage}`);
};

export const postYoutubeVideo = async (value, videoUrl) => {
  return axios
    .post(API.VIDEO + `?title=${value}&url=${videoUrl}`)
    .then()
    .catch((ex) => {
      if (ex.response.status === 401) {
        window.location.href = `/admin/login`;
        alert("접근권한이 없습니다.");
      } else {
        alert("서버에 이상이 있습니다. 관리자에게 문의주세요");
      }
    });
};

export const editYoutubeVideoData = async (id, value, videoUrl) => {
  axios
    .put(API.VIDEO + `/${id}?title=${value}&url=${videoUrl}`, {})
    .then()
    .catch((ex) => {
      if (ex.response.status === 401) {
        window.location.href = `/admin/login`;
        alert("접근권한이 없습니다.");
      } else {
        alert("서버에 이상이 있습니다. 관리자에게 문의주세요");
      }
    });
};

export const deleteYoutubeVideoData = async (id) => {
  axios
    .delete(API.VIDEO + `/${id}`, {})
    .then()
    .catch((ex) => {
      if (ex.response.status === 401) {
        window.location.href = `/admin/login`;
        alert("접근권한이 없습니다.");
      } else {
        alert("서버에 이상이 있습니다. 관리자에게 문의주세요");
      }
    });
};
